export default "__VITE_ASSET__EHquMFVh__"